if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      this.loadDeferredImages();
      super.show(opener);
      this.showActiveMedia();
    }

    // Speed fix: modal images ship with data-sy-src/data-sy-srcset (see snippets/product-media-modal.liquid) so they only download once the modal is opened.
    loadDeferredImages() {
      this.querySelectorAll('img[data-sy-src]').forEach((img) => {
        if (img.dataset.sySrcset) img.setAttribute('srcset', img.dataset.sySrcset);
        img.setAttribute('src', img.dataset.sySrc);
        img.removeAttribute('data-sy-srcset');
        img.removeAttribute('data-sy-src');
      });
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      if (!activeMedia) return;
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
